<template>
    <div id="LocationList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Location List</div>
                    <div class="btn-groups">
                        <router-link v-if="canAddLocation" class="btn btn-primary" v-bind:to="{name: 'LocationCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        <button  class="btn btn-tertiary" style= "margin-left: 6px" v-on:click.prevent='CopyGlCode("open")' >Copy GL Code</button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content location-list">
                        <data-table-filter-config :moduleName="'locationList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'locationList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listLocationTable"
                                    mode="remote"
                                    title="Location"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateLocation">
                                                    <router-link title="Edit Location" class="fp-edit  mr-3" v-bind:to="{name: 'LocationEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <template v-if="canViewLocation">
                                                    <router-link title="View Location"  v-bind:key="'action' + key " class="fp-view" v-bind:to="{name: 'LocationView',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="location_value" id="deleteLocationBtn" v-on:click.prevent="LocationDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            <!-- </div> -->
                        </section>
                        <!-- Model For Copying Gl Code For New Location ID -->
                        <div class="modal fade" id="CopyGlCodeModal" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        Copy GL Code
                                        <button type="button" class="close" data-dismiss="modal" v-on:click.prevent='CopyGlCode("close")'>&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <form id="copyglcode">
                                            <div>
                                                <label class="control-label require" for="gl_code">From:</label>
                                                <v-select v-model="base_location_id" name="base_location_id" placeholder="Select Code From ."
                                                        label="text"
                                                        :options="locationArr">
                                                </v-select>
                                                <div class="field-error">{{ gl_error_msg }}</div>
                                            </div>
                                            <div>
                                                <label class="control-label require" for="gl_code_to">To:</label>
                                                <v-select v-model="location_id" name="location" placeholder="Select Code To ."
                                                        label="text"
                                                        :options="locationArr">
                                                </v-select>
                                                <div class="field-error">{{ gl_to_error_msg }}</div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" id="saveCopyGlCode" class="btn btn-tertiary" data-dismiss="modal" v-on:click.prevent='CopyGlCode("close")' > <i class="fp-close"> </i> Cancel</button>
                                        <button type="button" id="cancelCopyGlCode" class="btn btn-primary" v-on:click.prevent='CopyGlCode("copy")' > <i class="fp-save"> </i> Copy</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";

import EventBus from "././event-bus";

import {contractMixins} from '../mixins/contractMixins';

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
    export default {
        name: "LocationList",
        metaInfo() {
            return {title: "Location List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        data: () => ({

            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Location',
                    field: 'company_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Company Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Time Zone',
                    field: 'timezone',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Time Zone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            location_value: false,
            loading:false,
            canUpdateLocation:false,
            canAddLocation:false,
            location_id: null,
            base_location_id: null,
            locationArr:[],
            glArrTo:[],
            gl_error_msg: "",
            gl_to_error_msg:"",
            canViewLocation:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_location') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_location') {
                            self.location_value = true;
                        }
                        if (permissions[i].name == 'add_location') {
                            self.canAddLocation = true;
                            self.canUpdateLocation = true;
                        }
                        if (permissions[i].name == 'view_location') {
                            self.canViewLocation = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;


            self.getPermissions();
            self.loadFieldData(['location']);

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listLocationTable.unselectAllInternal();
            },

            CopyGlCode(flag){
               var self = this;
               var error = false;
               self.gl_error_msg = "";
               self.gl_to_error_msg = "";
               if (flag == "open") {

                    $('#CopyGlCodeModal').modal('show');

                } else if (flag == "close") {

                    self.gl_code = null;
                    self.gl_code_to = null;


                    $('#CopyGlCodeModal').modal('hide');

                } else{

                  if(self.base_location_id == null || !self.base_location_id.value) {

                        self.gl_error_msg = "Location Code Required.";
                        error = true;
                    }
                  if (self.location_id == null || !self.location_id.value) {
                        self.gl_to_error_msg = "Location Required.";
                        error = true;
                    }

                    if (!error) {
                      $("#saveCopyGlCode").text("Copying ...");
                      $("#saveCopyGlCode").prop("disabled", true);
                      $("#cancelCopyGlCode").prop("disabled",true);

                      var fields = $("#copyglcode").serializeArray();
                      fields.push({name: "base_location_id", value: self.base_location_id.value});
                      fields.push({name: "location_id", value: self.location_id.value});

                       $.ajax({
                            url: process.env.ROOT_API + "/location/copy",
                            type: "POST",
                            data: fields,
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;

                                $("#saveCopyGlCode").text("Copy");
                                $("#saveCopyGlCode").prop("disabled", false);
                                $("#cancelCopyGlCode").prop("disabled",false);

                                if (data.status == "success") {

                                    // console.log(data.content);
                                    self.base_location_id = null;
                                    self.location_id = null;


                                    $('#CopyGlCodeModal').modal('hide');
                                   self.$router.push("/gl-account/list");
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;

                                $("#saveCopyGlCode").text("Save");
                                $("#saveCopyGlCode").prop("disabled", false);
                                $("#cancelCopyGlCode").prop("disabled",false);

                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server cannot be reached";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("tkn");

                                        self.$router.push("/");
                                    }

                                }
                            }
                        });
                    }else{
                      self.errorValidationFocus();
                    }
                }
            },

            LocationCreatePage(){
                var self = this;
                self.$router.push("/location/create");
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/location/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;

                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'location-list')
                    }
                });
            },

            LocationDelete() {
                var data = this.$refs['listLocationTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listLocationTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Location? ')) {
                    self.loading = true;
                    $("#deleteLocationBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/location/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteLocationBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'location-delete')
                        }
                    });
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/LocationList.vue